<mapfre-modal
  [modalOptions]="uploadingFiles"
  [hideModal]="hideModal"
  (closeModal)="resetHideModal($event)"
>
  <div class="modal-body no-margin-top margin-bottom mb8 upload-file-modal-container">
    <ng-container *ngIf="isAcmic; else maHeader">
      <hr class="no-margin-bottom no-margin-top" />
    </ng-container>
    <ng-template #maHeader>
      <div class="ma-modal-title">{{'Uploading file' | translate}}</div>                                                                
    </ng-template>

    <div class="uploading-files margin-top mt24 text-center">
      <ng-container *ngIf="!invalidFileType">
        <section class="uploading-inner-block ml-auto mr-auto">
          <div>
            <img src="./assets/img/images/icon-uploading-files.svg" alt="uploading files icon" />
          </div>
          <div class="info-consideration margin-top mt16">
            {{ uploadedFile }}
          </div>

          <div class="mt-3 progress" style="height: 24px">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 100%"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              100%
            </div>
          </div>
          <div class="select-type-doc margin-top mt24">
            <label for="select-topic" class="select-label">
              {{ "Type *" }}
            </label>
            <select
              class="form-control selection-input-color mb8"
              name="select-topic"
              [(ngModel)]="documentType"
            >
              <option value="" disabled selected>Select type of document</option>
              <option>Scene Photos</option>
              <option>Vehicle Photos</option>
              <option>Incident Reports</option>
              <option>Receipts/Invoices</option>
              <option>Other</option>
            </select>
          </div>
        </section>
      </ng-container>
      <ng-container *ngIf="invalidFileType === 'too_big'">
        <section class="uploading-container">
          <div>
            <img src="./assets/img/images/icon-uploading-files-warn.svg" alt="uploading files warn icon" />
          </div>
          <div class="problem-uploading margin-top mt16">
            {{ "Problem uploading file:" | translate }}
          </div>
          <div class="problem-uploading">
            {{ uploadedFile }}
          </div>

          <div class="margin-top mt24 exceeds-message text-danger">
            {{
              "The file you are trying to upload exceeds the 50MB attachment limit"
            }}
          </div>
          <div class="margin-top mt24 send-email-message mb-4">
            {{ "Please email the document to " | translate }}
            <ng-container *ngIf="isAcmic; else maState">
              <a href="mailto:claimsmail@Insure.WA.AAA.com" target="_blank" rel="noopener">{{
                " claimsmail@Insure.WA.AAA.com," | translate
              }}</a>
            </ng-container>
            <ng-template #maState>
              <a
                href="mailto:claimsmail@mapfreusa.com"
                target="_blank"
                class="mapfre link underline red-link" rel="noopener"
                >{{ " claimsmail@mapfreusa.com," | translate }}</a
              >
            </ng-template>
            <div>{{"make sure you include your claim number." | translate }}</div>
          </div>
        </section>
        <app-brwose-files></app-brwose-files>
      </ng-container>
      <ng-container *ngIf="invalidFileType === 'invalid_format'">
        <section class="uploading-container">
          <div>
            <img src="./assets/img/images/icon-uploading-files-warn.svg" alt="uploading files warn icon" />
          </div>
          <div class="problem-uploading margin-top mt16">
            {{ "Problem uploading file:" | translate }}
          </div>
          <div class="problem-uploading">
            {{ uploadedFile }}
          </div>

          <div class="margin-top mt24 send-email-message text-danger">
            {{ "Incorrect file format." }}
          </div>
          <div class="send-email-message text-danger mb-4">
            {{ "Please use JPEG, PDF, GIF, or PNG." }}
          </div>
          <app-brwose-files></app-brwose-files>
        </section>
      </ng-container>
    </div>
    <hr class="ma-hr-tag" *ngIf="!isAcmic">
    <div class="display-right margin-top mt24">
      <mapfre-button
        *ngIf="invalidFileType"
        (click)="onClickBack()"
        additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17"
        >{{ "CANCEL" | translate }}
      </mapfre-button>
      <ng-container *ngIf="!invalidFileType">
        <section class="show-btn-order">
          <mapfre-button
            (click)="onClickBack()"
            additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17"
            >{{ "CANCEL" | translate }}
          </mapfre-button>
          <mapfre-button
            (click)="saveUploadFile()"
            additionalClasses="basic primary small-btn margin-bottom modal-small-btn letter-space-17"
            [inputType]="'submit'"
            [disabledValue]="documentType?.length"
            [translateValue]="'Save' | translate"
          >
            {{ "Save" | translate }}
          </mapfre-button>
        </section>
      </ng-container>
    </div>
  </div>
</mapfre-modal>
